__turbopack_context__.v({
  "spin": "spinner-module-scss-module__--vZkW__spin",
  "spinner": "spinner-module-scss-module__--vZkW__spinner",
});
